
import * as angular from "angular";
import { UserPreferencesService } from "../userPreferences/service/userpreferences.service";

export interface IAutocompleteResponse {
    results: IAutoCompleteResult[];
}

export interface IAutoCompleteResult {
    formatted: string;
    geometry: IMapzenAutoCompleteGeometry;
}

export interface IMapzenAutoCompleteGeometry {
    lat: number;
    lng: number;
}

export class MapzenService {

    static $inject = ["$http", "userPreferencesService"];

    constructor(
        private readonly $http: angular.IHttpService,
        private readonly userPreferencesService: UserPreferencesService) {
    }

    autocomplete(text: string, countryCode: string): angular.IPromise<IAutocompleteResponse> {

        if (!countryCode) {
            countryCode = "GB";
        }

        if (text.length > 1) {
            return this
                .$http({
                    url: `/api/map/autocomplete/${encodeURIComponent(text)}/${countryCode}`,
                    method: "GET",
                    cache: true,
                    params: { minsToLive: 60 }
                })
                .then((response: angular.IHttpPromiseCallbackArg<IAutocompleteResponse>) => {
                    return response.data;
                });
        }

    }
}
